module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "noselect",
    class: _vm.it,
    style: ({
      borderTopColor: _vm.cssPropColor('$color-border')
    })
  }, [(_vm.loaded) ? _c('branding', {
    attrs: {
      "logo": _vm.company.logo,
      "altText": _vm.company.company_name,
      "link": _vm.company.url,
      "linkTarget": "_blank"
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "company-nav-transition",
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated slideOutDown"
    }
  }, [(_vm.hasEntered) ? _c('nav', {
    staticClass: "company",
    style: ({
      borderRightColor: _vm.cssPropColor('$color-border'),
      borderLeftColor: _vm.cssPropColor('$color-border')
    })
  }, [_c('ul', [((_vm.aboutPosition === 'footer')) ? _c('li', {
    style: ({
      borderRightColor: _vm.cssPropColor('$color-border')
    })
  }, [_c('a', {
    class: {
      active: (_vm.activePanel === 'panel-content-about')
    },
    attrs: {
      "title": "About"
    },
    on: {
      "click": function($event) {
        _vm.togglePanel('panel-content-about', 'about-us', $event)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_information",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("About")])])]) : _vm._e(), _vm._v(" "), (_vm.hasCoverages) ? _c('li', [_c('a', {
    class: {
      active: (_vm.activePanel === 'panel-content-coverages')
    },
    style: ({
      borderRightColor: _vm.cssPropColor('$color-border')
    }),
    attrs: {
      "title": "Additional Coverages"
    },
    on: {
      "click": function($event) {
        _vm.togglePanel('panel-content-coverages', 'additional-coverages', $event)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_additional",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.addCoverageLabel)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: (_vm.activePanel === 'panel-content-contact')
    },
    style: ({
      borderRightColor: _vm.cssPropColor('$color-border')
    }),
    attrs: {
      "title": "Contact Us"
    },
    on: {
      "click": function($event) {
        _vm.togglePanel('panel-content-contact', 'contact-us', $event)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_contact",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_label)
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "legal-nav-transition",
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated slideOutDown"
    }
  }, [(_vm.hasEntered) ? _c('nav', {
    staticClass: "legal"
  }, [_c('ul', [_c('li', [_c('a', {
    class: {
      active: (_vm.activePanel === 'panel-content-privacy')
    },
    attrs: {
      "title": "Privacy Policy"
    },
    on: {
      "click": function($event) {
        _vm.togglePanel('panel-content-privacy', 'privacy-policy', $event)
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Privacy Policy")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: (_vm.activePanel === 'panel-content-terms')
    },
    attrs: {
      "title": "Terms and Conditions"
    },
    on: {
      "click": function($event) {
        _vm.togglePanel('panel-content-terms', 'terms-of-service', $event)
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Terms and Conditions")])])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f7c8ec0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
// module id = 449
// module chunks = 1